import React, { Component } from "react";
import { connect } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import * as actionCreator from "../../../../action/index.js";
import Prices from "./Prices.js";
import Total from "./Total.js";
import DepositDiscount from "./DepositDiscount.js";
import Deposit from "./Deposit.js";
import TotalDiscount from "./TotalDiscount.js";
import CurrencyFormat from "react-currency-format";
import GrandTotal from "./GrandTotal.js";
var opendropdown = document.getElementsByClassName("App");
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

class DepositOrder extends Component {
  constructor(props){
    super(props)
  }
   fortoggleevent() {
    if (opendropdown[0].classList.contains("activedrpdwn")) {
      opendropdown[0].classList.remove("activedrpdwn");
      this.props.handleShowOverlay(false);
    } else {
      opendropdown[0].classList.add("activedrpdwn");
      this.props.handleShowOverlay(true);
      if(window.innerWidth > 992 && this.props.isShowPhotoModal) {
        this.props.handleShowPhotoModal();
      }
    }
  }

  render() {
    let manufacturer_discount =
      this.props.const_var.post_data.building != undefined &&
      this.props.const_var.post_data.building.discount_amount != undefined &&
      this.props.const_var.post_data.building.discount_amount != 0;

    let dealer_discount =
      this.props.const_var.post_data.building != undefined &&
      this.props.const_var.post_data.building.down_payment_discount_total !=
        undefined &&
      this.props.const_var.post_data.building.down_payment_discount_total !=
        0 &&
      this.props.const_var.BuildingPriceArrar["down_payment_discount_total"] !=
        0;


    let surValue = "";
    let surFlag = false;
    if (
      this.props.const_var.BuildingPriceArrar["surcharge_amount"] !=
        undefined &&
      this.props.const_var.BuildingPriceArrar["surcharge_amount"] != 0 &&
      this.props.const_var.stateManufacturerAcordingAPIDiscount["surcharge"] !=
        undefined &&
      this.props.const_var.stateManufacturerAcordingAPIDiscount["surcharge"][
        this.props.params.m_s_n
      ] !== undefined
    ) {

      if (
        this.props.const_var.post_data.building != undefined &&
        this.props.const_var.post_data.building.surcharge_taxable != 0
      ) {
        surValue = "(+Surcharge)";
      } else {
        surValue = "";
      }
      if (
        this.props.const_var.post_data.building != undefined &&
        this.props.const_var.post_data.building
          .surcharge_on_discounted_subtotal == 1
      ) {
        surFlag = true;
      } else {
        surFlag = false;
      }
    }

    function viewTotalprice() {
      const removea = document.querySelector("body");
      removea.classList.add("active-total-price");
    }
    return (
      <div className="drop-inner-price deposit-order-wrapper">
        <span className={ this.props.const_var.is_loader == true ? "active saving-effect saving-effect-type-2" : "saving-effect saving-effect-type-2" }>
          <span></span><span></span><span></span>
        </span>
        <Dropdown className="dropdown-price" onToggle={e=>this.fortoggleevent()}>
          <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" className="dropdown-toggle">
            {/* <label class="nav-info-name">{dealer_discount ? "Dis. Deposit" : "Deposit"} (Price <Total />)</label> */}
            {
              this.props.const_var.loginSession == true 
                ?
                  (this.props.const_var.stateData != undefined && this.props.const_var.stateData.loggedin_price_type != undefined &&  this.props.const_var.stateData.loggedin_price_type == 1)
                  ? 
                  
                  <label class="nav-info-name">Grand Total : 
                    <span className="main-price">
                      <GrandTotal/>     
                    </span>
                  </label>
                  :
                    <label class="nav-info-name">Sub Total : 
                      <span className="main-price">
                        {manufacturer_discount ? <del className="line-color-red"><Total/></del> : <span className="color-dark"><Total/></span>}
                        {manufacturer_discount ? <span className="color-dark ml-1"><TotalDiscount /></span> : null} 
                      </span>
                    </label>
                :
                  (this.props.const_var.stateData != undefined && this.props.const_var.stateData.visitors_price_type != undefined && this.props.const_var.stateData.visitors_price_type == 1) 
                  ? 
                    <label class="nav-info-name">Grand Total : 
                      <span className="main-price">
                      <GrandTotal/>      
                      </span>
                    </label>
                  :
                  <label class="nav-info-name">Sub Total : 
                    <span className="main-price">
                      {manufacturer_discount ? <del className="line-color-red"><Total/></del> : <span className="color-dark"><Total/></span>}
                      {manufacturer_discount ? <span className="color-dark ml-1"><TotalDiscount /></span> : null} 
                    </span>
                  </label>
            }
            <label class="nav-info-value"> 
              <span className="nav-info-name font-weight-normal">Deposit : </span>
              <span className="text">
                {dealer_discount ? <del className="line-color-red"><Deposit /></del> : <Deposit />}  
                {dealer_discount ? <DepositDiscount /> : null}</span>
              <span className="icon caret"><i className={`${this.props.isShowOverlay ? 'icon-arrow-up-ico': 'icon-arrow-down-ico'}`}></i></span>
            </label>
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu-price">
            <div className="deposit-dropdown-wrapper">
              {
                <Prices/>
              }
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.reducer,
    ...state.orderExtrasReducer,
    ...state.priceUpdateReducer,
  };
};

export default connect(mapStateToProps, actionCreator)(DepositOrder);
